import React, { Component } from "react";
import ReactDOM from "react-dom";
import isMobile from "is-mobile";
import PropTypes from "prop-types";
import "./Bars.scss";

import Legends from "./Legends";
import Bar from "./Bar";

class Bars extends Component {
  static propTypes = {
    data: PropTypes.array,
    isVertical: PropTypes.bool,
    legends: PropTypes.array,
    uniqueId: PropTypes.string,
    unresponsive: PropTypes.bool // eslint-disable-line react/boolean-prop-naming
  };

  static defaultProps = {
    data: [],
    isVertical: null,
    legends: [],
    uniqueId: "",
    unresponsive: false
  };

  /* eslint-disable react/sort-comp */
  prevWidth = 0;

  state = {
    width: 0,
    height: 0,
    isVertical:
      this.props.isVertical !== null ? this.props.isVertical : !isMobile(),
    maxValue: 0
  };
  /* eslint-enable */

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    const items = this.props.data && this.props.data.map(({ data }) => data);
    this.setHighestNumber(items);

    if (this.wrapper) {
      /* eslint-disable react/no-find-dom-node */
      const wrapper = ReactDOM.findDOMNode(this.wrapper);

      const { width, height } = wrapper.getBoundingClientRect();

      this.setState({
        width,
        height
      });
    }
  }

  componentDidUpdate(prevProps) {
    const isUniqueIdChanged = prevProps.uniqueId !== this.props.uniqueId;
    const isFirstTimeData =
      prevProps.data && !prevProps.data.length && this.props.data;

    if (isUniqueIdChanged || isFirstTimeData) {
      const items = this.props.data.map(({ data }) => data);
      this.setHighestNumber(items);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  setHighestNumber = data => {
    let maxValue = 0;

    /* eslint-disable no-plusplus */
    for (let i = 0; i < data.length; i++) {
      const array = data[i];
      const localMax = Math.max(...array);

      if (localMax > maxValue) {
        maxValue = localMax;
      }
    }

    this.setState({
      maxValue
    });
  };

  updateDimensions = () => {
    if (this.props.unresponsive) {
      return;
    }

    /*
     * We're doing a check with an if stetment instead of inside this.setState
     * in order to prevent rerender by setting the state each resize event
     */
    if (this.prevWidth > 786 && window.innerWidth < 786) {
      this.setState({
        isVertical: false
      });
    }

    if (this.prevWidth < 786 && window.innerWidth > 786) {
      this.setState({
        isVertical: true
      });
    }

    this.prevWidth = window.innerWidth;
  };

  render() {
    const { width, height, isVertical, maxValue } = this.state;
    const { legends, data, isVisible, hasBackgroundLines } = this.props;

    return (
      <div
        ref={ref => {
          this.wrapper = ref;
        }}
        className={`bars ${isVertical ? "bars--vertical" : ""}`}
      >
        {isVertical ? null : (
          <Legends legends={legends} className="bars__legends" />
        )}
        <div className="bars__wrapper">
          <div
            className={`bars__main ${isVertical ? "bars__main--vertical" : ""}`}
          >
            {data
              ? data.map(props => (
                  <Bar
                    key={props.tag}
                    hasBackgroundLines={hasBackgroundLines}
                    {...props}
                    width={width}
                    height={height}
                    isVertical={isVertical}
                    maxValue={maxValue}
                    isVisible={isVisible}
                    numberOfBars={data.length}
                  />
                ))
              : null}
          </div>
        </div>
        {isVertical ? <Legends legends={legends} isVertical /> : null}
      </div>
    );
  }
}

export default Bars;
